export function CalcDistBottom(theLayout, pageLayoutMgr) {
  var pageHeight = pageLayoutMgr.GetPageHeight();
  var y = theLayout.GetPositionY();
  var distBottom = pageHeight - y;

  return distBottom;
}
